var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategiesProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9163 13.5417V9.37504C22.9163 4.16671 20.833 2.08337 15.6247 2.08337H9.37468C4.16634 2.08337 2.08301 4.16671 2.08301 9.37504V15.625C2.08301 20.8334 4.16634 22.9167 9.37468 22.9167H13.5413",
    stroke: "#ED5D65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63574 15.0938L10.1149 11.875C10.4691 11.4167 11.1253 11.3333 11.5837 11.6875L13.4899 13.1875C13.9483 13.5417 14.6045 13.4583 14.9587 13.0104L17.3649 9.90625",
    stroke: "#ED5D65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2921 16.4791L20.5838 17.0729C20.7296 17.3645 21.0942 17.6354 21.4171 17.6979L21.8129 17.7604C23.0004 17.9583 23.2817 18.8333 22.4275 19.6979L22.0629 20.0624C21.8233 20.3124 21.6879 20.7916 21.7609 21.125L21.8129 21.3437C22.1358 22.7812 21.3754 23.3333 20.1254 22.5833L19.8546 22.427C19.5317 22.2395 19.0108 22.2395 18.6879 22.427L18.4171 22.5833C17.1567 23.3437 16.3963 22.7812 16.7296 21.3437L16.7817 21.125C16.8546 20.7916 16.7192 20.3124 16.4796 20.0624L16.115 19.6979C15.2608 18.8333 15.5421 17.9583 16.7296 17.7604L17.1254 17.6979C17.4379 17.6458 17.8129 17.3645 17.9587 17.0729L18.2504 16.4791C18.8129 15.3437 19.7296 15.3437 20.2921 16.4791Z",
    stroke: "#ED5D65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategiesProducts);
export default __webpack_public_path__ + "static/media/strategies_products.212e4040e95d337fd34826d712d6dfc9.svg";
export { ForwardRef as ReactComponent };